import React from "react";
import SignUpLayerCustom from "../components/SignUpLayerCustom";
import MasterLayout from "../masterLayout/MasterLayout";

const SignUpPage = () => {
  return (
    <>
      <MasterLayout>
      {/* SignUpLayer */}
      <SignUpLayerCustom />
      </MasterLayout>
    </>
  );
};

export default SignUpPage; 
